import { Spacing, Text } from '@vkontakte/vkui';
import img from 'img/family/familyDocuments.png';
import imgDark from 'img/family/familyDocumentsDark.png';
import React, { useEffect, useMemo } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import styles from 'reactApp/ui/LitresModal/LitresModal.css';

export interface FamilyDocumentsModalProps {
    onClose: () => void;
    onShow: () => void;
    onClick: () => void;
}

export function FamilyDocumentsModal({ onClose, onShow, onClick }: FamilyDocumentsModalProps) {
    useEffect(() => {
        onShow();
    }, []);

    const content = useMemo(
        () => (
            <div className={styles.content}>
                <Spacing size={12} />
                <Text className={styles.text}>
                    Складывайте в эту папку общие документы —<br />
                    не придётся искать паспорта, покупая билеты в отпуск.
                    <br />
                    Файлы из папки сохранятся и в <strong>Личных документах</strong>
                </Text>
                <Spacing size={24} />
            </div>
        ),
        []
    );

    return (
        <WhatsNewDialog
            title="Папка Документы семьи уже готова, осталось включить распознавание"
            titleClassName={styles.title}
            imageUrl={isDarkTheme ? imgDark : img}
            content={content}
            contentClassName={styles.wsncontent}
            onClick={onClick}
            onClose={onClose}
            imageBgColor="var(--vkui--color_background_modal)"
            buttonTheme="vk"
            dialogSize="tiny"
            qaId="family-documents-modal"
            primaryButtonText="Включить распознавание"
            closeAfterClick={true}
        />
    );
}
